export const Errors = {
  NO_DATE_ENTER: 'Date Of Birth is required.',
  FORMAT_ERROR_DATE: 'Enter a date in MM/DD/YYYY format.',   
};

export const ErrorCodes = {
  OKTA_COMMON_PASSWORD_ERROR_CODE: "QRA016",
  INVALID_PHONE_NUMBER_ERROR_CODE: "QRA017",
  PASSWORD_CONTAIN_USERNAME_ERROR_CODE: "QRA019",
};
